/*
 * @Author: 李明明
 * @Date: 2022-07-29 14:16:23
 * @LastEditTime: 2024-04-22 15:06:58
 * @LastEditors: 李明明
 * @Description:
 * @FilePath: /ykt-micro-main/src/api/home.js
 * 代码版权方：'政府采购信息网'
 */
import axios from "@/utils/axios";
let { post } = axios;

// 获取研修班类型列表
export const homePage = (data) => post("home/homePage", data);
// 获取研修班列表
export const listCourse = (data) => post("/home/listCourse", data);
// 获取订单列表
export const listMyOrder = (data) => post("/my/listMyOrder", data);
// 获取首页广告接口
export const listAdvert = (data) => post("/home/listAdvert", data);
// 获取首页消息接口
export const getYktMessage = (data) => post("/home/getYktMessage", data);
// 获取学习页面广告接口
export const listStudyAdvert = (data) => post("/home/listStudyAdvert", data);
// 增加广告点击量接口
export const addAdvertClickNumber = (data) =>
  post("/home/addAdvertClickNumber", data);
// 获取山西研修班列表
export const listCourseByIdList = (data) =>
  post("/home/listCourseByIdList", data);
// 获取用户是否为陕西研修班专家
export const getShanxiExamInfo = (data) =>
  post("/home/getShanxiExamInfo", data);
// 获取专家是否为山西专项专家
export const getMyMenuForShanxi = (data) =>
  post("/my/getMyMenuForShanxi", data);
// 获取山东广告配置
export const getShanDongInfo = (data) => post("/home/getShanDongInfo", data);
